<script>
  import { CreateShortlink, Shortlinks } from '@button/ui';
  import Layout from '../components/Layout.svelte';
  import { isShowingHelpModal } from '../store';

  let newlyCreatedShortlinkName = false;
</script>

<Layout>
  <CreateShortlink bind:newlyCreatedShortlinkName {isShowingHelpModal} />
  <Shortlinks bind:newlyCreatedShortlinkName />
</Layout>
